/* De React Query-sleutels van de sites, op één plek (F9.12).
 *
 * De sitepagina onthoudt een site 60 seconden (staleTime). Wie een site in de UI
 * bewerkt, aanmaakt of verwijdert, moet die sleutels daarna ongeldig maken; anders
 * toont /crm/sites/:siteId tot een minuut lang de oude naam, of een site die al
 * verwijderd is. Alle sleutels van sites beginnen met SITES_SLEUTEL, dus één
 * invalidatie op dat voorvoegsel raakt de pagina van elke site en elke lijst. */

export const SITES_SLEUTEL = ['sites'] as const;

export const siteSleutel = (siteId: string | undefined) => [...SITES_SLEUTEL, 'site', siteId] as const;

/** Na elke wijziging aan public.sites vanuit de UI. */
export function naSiteWijziging(qc: { invalidateQueries(filters: { queryKey: readonly unknown[] }): Promise<void> }): Promise<void> {
  return qc.invalidateQueries({ queryKey: SITES_SLEUTEL });
}
